import React, { useState } from "react";
import { Field, FormSection, reduxForm } from "redux-form";
import { CircularProgress } from "@mui/material";
import { Collapse, Icon, notification } from "antd";
import { useDispatch } from "react-redux";
import moment from "moment";

import SwmsInfoSection from "./SwmsInfoSection";
import OurCompanySection from "./OurCompanySection";
import ClientContractorSection from "./ClientContractorSection";
import AuthorisationDetailsSection from "./AuthorisationDetailsSection";
import VersionHistorySection from "./VersionHistorySection";
import DisplayFieldValue from "../../../../common/DisplayFieldValue";
import JobSwmsDetailsSection from "./JobSwmsDetailsSection";
import ReviewsSection from "./ReviewsSection";
import TaskDetailsSection from "./TaskDetailsSection";
import HighRisksSection from "./HighRisksSection";
import PermitsSection from "./PermitsSection";
import PlantEquipmentSection from "./PlantEquipmentsSection";
import MaterialsSection from "./MaterialsSection";
import ToolsSection from "./ToolsSection";
import PPESection from "./PPESection";
import TrainingLicensesCompetenciesSection from "./TrainingLicensesCompetenciesSection";
import LegislationStandardCOPSection from "./LegislationStandardCOPSection";
import RiskMatrixSection from "./RiskMatrixSection";
import KeyContactsSection from "./KeyContactsSection";
import SwmsConsultationsSection from "./SwmsConsultationsSection";

import { saveSwmsForm } from "../../../../../actions/v2/JobSwmsActions";
import { Strings } from "../../../../../dataProvider/localize";
import styles from "../../JobStyle.module.css";
import { CustomSwitch } from "../../../../common/customSwitch";
import JSASection from "./JSASection";
import SdsSection from "./SdsSection";
import JSASection2 from "./JSASection2";
import "../JobSwmsPreview/PreviewSwmsStyle.css";

const { Panel } = Collapse;

const formatSection = (values, sectionName, arrayName = "data") => {
  let selected = {};
  try {
    if (values[sectionName]) {
      if (values[sectionName].selected) {
        let arr = [...values[sectionName].selected];
        let allEnabled = [];
        if (values[sectionName].enabled) {
          for (let key in values[sectionName].enabled) {
            if (values[sectionName].enabled[key] === true) {
              allEnabled.push(key.slice(key.indexOf("_") + 1).toString());
            }
          }
        }
        // console.log(sectionName, allEnabled, selected[arrayName]);
        selected[arrayName] = arr.map(({ label, value, ...x }) => ({ ...x, selected: allEnabled.indexOf(x.id.toString()) !== -1 ? 1 : 0 }))
        selected.toggle = values[sectionName].toggle && values[sectionName].toggle === true ? 1 : 0
      }
    }
  } catch (err) {
    console.log(err);
  }
  return selected;
}

// TODO: Remove before merging — dummy data for UI preview of FM-796 / FM-798
const DUMMY_APPROVERS = [
  {
    role: "creator",
    name: "Amir Jelvani",
    position: "Rope Access Manager",
    date: "2025-11-03T00:00:00Z",
    name_initials: "A. Jelvani",
    signature: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNTAiIGhlaWdodD0iNTAiPjxwYXRoIGQ9Ik01LDM1IEMxNSwxMCAyNSw0NSA0MCwyOCBDNTUsMTIgNjgsNDAgODAsMjUgQzk1LDEwIDEwOCwzOCAxMjUsMjggQzEzMywyMiAxNDAsMzIgMTQ1LDMwIiBzdHJva2U9IiMxZTNhOGEiIGZpbGw9Im5vbmUiIHN0cm9rZS13aWR0aD0iMi41IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz48L3N2Zz4=",
  },
  {
    role: "signed",
    name: "Kevin Docherty",
    position: "NSW General Manager",
    date: "2025-11-04T00:00:00Z",
    in_document: true,
    name_initials: "K. Docherty",
    signature: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNTAiIGhlaWdodD0iNTAiPjxwYXRoIGQ9Ik01LDM1IEMxNSwxMCAyNSw0NSA0MCwyOCBDNTUsMTIgNjgsNDAgODAsMjUgQzk1LDEwIDEwOCwzOCAxMjUsMjggQzEzMywyMiAxNDAsMzIgMTQ1LDMwIiBzdHJva2U9IiMxZTNhOGEiIGZpbGw9Im5vbmUiIHN0cm9rZS13aWR0aD0iMi41IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz48L3N2Zz4=",
  },
  {
    role: "signed",
    name: "Sarah Mitchell",
    position: "Operations Director",
    date: "2025-11-04T00:00:00Z",
    in_document: false,
    name_initials: "S. Mitchell",
    signature: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNTAiIGhlaWdodD0iNTAiPjxwYXRoIGQ9Ik01LDM1IEMxNSwxMCAyNSw0NSA0MCwyOCBDNTUsMTIgNjgsNDAgODAsMjUgQzk1LDEwIDEwOCwzOCAxMjUsMjggQzEzMywyMiAxNDAsMzIgMTQ1LDMwIiBzdHJva2U9IiMxZTNhOGEiIGZpbGw9Im5vbmUiIHN0cm9rZS13aWR0aD0iMi41IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz48L3N2Zz4=",
  },
  {
    role: "pending",
    name: "David Cameron",
    position: "HSEQ Manager",
    name_initials: "D. Cameron",
  },
];

const DUMMY_VERSION_HISTORY = [
  {
    version_number: "v3",
    swms_id: "SWMS-2025-003",
    created_at: "2025-11-01T00:00:00Z",
    created_by: "Amir Jelvani",
    status: "in_progress",
    edit_note: "Updated fall arrest equipment requirements to comply with AS/NZS 1891.4:2009.",
    edit_text: "Updated fall arrest equipment requirements to comply with AS/NZS 1891.4:2009.",
    submissions: [
      {
        sent_at: "2025-11-02T00:00:00Z",
        reviewer_count: 2,
        reviewers: [
          {
            name: "Kevin Docherty",
            position: "NSW General Manager",
            status: "approved",
            responded_at: "2025-11-03T00:00:00Z",
          },
          {
            name: "David Cameron",
            position: "HSEQ Manager",
            status: "pending",
          },
        ],
      },
    ],
  },
  {
    version_number: "v2",
    swms_id: "SWMS-2025-002",
    created_at: "2025-10-15T00:00:00Z",
    created_by: "Amir Jelvani",
    status: "superseded",
    edit_note: "Added noise control measures for level 3 areas.",
    edit_text: "Added noise control measures for level 3 areas.",
    submissions: [
      {
        sent_at: "2025-10-16T00:00:00Z",
        reviewer_count: 2,
        reviewers: [
          {
            name: "Kevin Docherty",
            position: "NSW General Manager",
            status: "approved",
            responded_at: "2025-10-18T00:00:00Z",
          },
          {
            name: "Sarah Mitchell",
            position: "Operations Director",
            status: "rejected",
            responded_at: "2025-10-17T00:00:00Z",
            rejection_notes: "JSA step 4 references incorrect PPE standard. Please update to AS/NZS 1337.1.",
          },
        ],
      },
      {
        sent_at: "2025-10-20T00:00:00Z",
        reviewer_count: 2,
        reviewers: [
          {
            name: "Kevin Docherty",
            position: "NSW General Manager",
            status: "approved",
            responded_at: "2025-10-21T00:00:00Z",
          },
          {
            name: "Sarah Mitchell",
            position: "Operations Director",
            status: "approved",
            responded_at: "2025-10-22T00:00:00Z",
          },
        ],
      },
    ],
  },
  {
    version_number: "v1",
    swms_id: "SWMS-2025-001",
    created_at: "2025-09-10T00:00:00Z",
    created_by: "Amir Jelvani",
    status: "superseded",
    edit_note: null,
    edit_text: null,
    submissions: [
      {
        sent_at: "2025-09-11T00:00:00Z",
        reviewer_count: 1,
        reviewers: [
          {
            name: "Kevin Docherty",
            position: "NSW General Manager",
            status: "no_response",
          },
        ],
      },
    ],
  },
];

const JobSwmsForm = ({ handleSubmit, onClose, id, swmsId, jobId, swms_data, swms_revision, highRiskData, change, likelihoods, consequences, risks, swms_number = "", templateVersion = 2 }) => {

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const onSubmit = (values) => {
    setLoading(true);

    let uploading = 0;
    let selected_permit_data = {};
    let enabledHRS = [];
    let hrsData = {};
    if (values.high_risk_section.enabled) {
      for (let key in values.high_risk_section.enabled) {
        if (values.high_risk_section.enabled[key] === true) {
          enabledHRS.push(key.slice(key.indexOf("_") + 1));
        }
      }
    }
    if (values.high_risk_section.data) {
      for (let key in values.high_risk_section.data) {
        hrsData[key] = values.high_risk_section.data[key].map(x => ({
          ...x,
          selected: enabledHRS.findIndex(y => y.toString() === x.id.toString()) !== -1 ? 1 : 0
        }))
      }
    }

    let allPerms = [];
    if (values.permits_section && values.permits_section.permits) {
      values.permits_section.permits.forEach(permit => {
        let permObj = {};
        if (permit.permit_name) {
          permObj.permit_name = permit.permit_name
        }
        if (permit.permit_document) {
          if (permit.permit_document.isUploaded) {

            permObj.permit_document = {
              file_name: permit.permit_document.file_name,
              visible_name: permit.permit_document.visible_name
            }
          } else {
            uploading++;
          }
        }
        if (Object.keys(permObj).length > 0) {
          allPerms.push(permObj);
        }
      })
      selected_permit_data.permits = allPerms;
      if (values.permits_section.toggle === true) {
        selected_permit_data.toggle = 1;
      } else {
        selected_permit_data.toggle = 0;
      }
    } else {
      selected_permit_data.toggle = 0;
    }

    let selected_ppe_section = formatSection(values, "ppe_section", "ppe_items");
    let selected_tools_section = formatSection(values, "tools_section", "tool_items");
    let selected_pe_section = formatSection(values, "plant_equipment_section", "plant_and_equipment_items");
    let selected_tlc_section = formatSection(values, "tlc_section", "training_and_license_items");
    let selected_lsc_section = formatSection(values, "lsc_section", "legislation_safety_acts_and_standard_items");
    let selected_materials_sec = formatSection(values, "materials_section", "material_items");
    let selected_sds = formatSection(values, "sds_section", "sds_items");

    let consulations = {};
    if (values.swms_consultation_section) {
      if (values.swms_consultation_section.swms_consultation_items) {
        consulations.swms_consultation_items = values.swms_consultation_section.swms_consultation_items;
      }
      if (values.swms_consultation_section.hasOwnProperty("toggle")) {
        consulations.toggle = values.swms_consultation_section.toggle === true ? 1 : 0
      }
    }
    let jsa_data = values.jsa_section && values.jsa_section.activities ? values.jsa_section.activities : [];
    let jsa_data_2 = values.jsa_section_2 && values.jsa_section_2.activities ? values.jsa_section_2.activities : [];

    let taskDetails = {};
    if (values.task_details_section) {
      taskDetails = { ...values.task_details_section };
      let allDocs = [];
      if (values.task_details_section.task_documents_images && values.task_details_section.task_documents_images.length > 0) {
        values.task_details_section.task_documents_images.forEach(doc => {
          if (doc.file_name && doc.file_name.isUploaded) {
            allDocs.push({
              file_name: doc.file_name.file_name,
              visible_name: doc.file_name.visible_name
            })
          } else {
            uploading++;
          }
        })
      }
      taskDetails = { ...taskDetails, task_documents_images: [...allDocs] }
    }

    const resolvedSwmsId = swmsId || id;

    const document = {
      ...swms_data,
      info_section: { ...(values.info_section ? { 
        ...values.info_section,
        areas: {
          toggle: values.info_section.areas && values.info_section.areas.toggle === true ? 1 : 0,
          values: values.info_section.areas && values.info_section.areas.values ? values.info_section.areas.values.map(x => x.value) : []
        },
        qli_areas: {
          toggle: values.info_section.qli_areas && values.info_section.qli_areas.toggle === true ? 1 : 0,
          value: values.info_section.qli_areas && values.info_section.qli_areas.value ? values.info_section.qli_areas.value.map(x => ({
            id: x.id,
            name: x.name,
            display_name: x.display_name
          })) : []
        },
        issue_date: values.info_section.issue_date ? moment(values.info_section.issue_date).format("YYYY-MM-DD") : null,
        } : {}) },
      client_details: { ...(values.client_details ? values.client_details : {}) },
      company_details: { ...(values.company_details ? values.company_details : {}) },
      key_contacts: { ...values.key_contacts_section, toggle: values.key_contacts_section.toggle === true ? 1 : 0 },
      ppe_details: selected_ppe_section,
      tool_details: selected_tools_section,
      plant_and_equipment_details: selected_pe_section,
      permits_section: selected_permit_data,
      training_and_licenses_details: selected_tlc_section,
      legislation_safety_acts_and_standards_details: selected_lsc_section,
      material_details: selected_materials_sec,
      sds_details: selected_sds,
      swms_consultations: { ...consulations },
      task_details: { ...values.task_details_section },
      activities: { swms_activities: [...jsa_data], toggle: values.jsa_section.toggle && values.jsa_section.toggle === true ? 1 : 0 },
      activities_v2: { swms_activities_v2: [...jsa_data_2], toggle: values.jsa_section_2.toggle && values.jsa_section_2.toggle === true ? 1 : 0 },
      swms_revisions_and_approvals: { ...values.swms_review_section, toggle: values.swms_review_section && values.swms_review_section.toggle === true ? 1 : 0 },
      risk_matrix_section: { toggle: values.risk_matrix_section && values.risk_matrix_section.toggle === true ? 1 : 0 },
      high_risk_activities: { high_risk_activities_item: { ...hrsData }, toggle: values.high_risk_section && values.high_risk_section.toggle === true ? 1 : 0 },
      task_details: { ...taskDetails },
      risk_ratings: { ...values.risk_ratings, ...(risks && risks.length > 0 ? { risk_rating_items: [...risks] } : {}) },
      ...(consequences && consequences.length > 0 ? { consequences: [...consequences] } : {}),
      ...(likelihoods && likelihoods.length > 0 ? { likelihoods: [...likelihoods] } : {})
    };

    const formData = {
      title: values && values.info_section && values.info_section.swms_name ? values.info_section.swms_name : "",
      document
    };
    if (uploading > 0) {
      notification.error({
        message: Strings.error_title,
        description: "One or more files are still uploading or they failed to upload.",
        className: "ant-error"
      });
      setLoading(false);
    } else {
      dispatch(saveSwmsForm(jobId, resolvedSwmsId, formData)).then(message => {
        setLoading(false);
        notification.success({
          message: Strings.success_title,
          message: message,
          className: "ant-success"
        });
        onClose();
      }).catch(err => {
        if (err) {
          setLoading(false);
          notification.error({
            message: Strings.error_title,
            description: err ? err : Strings.generic_error,
            className: "ant-error"
          });
        }
      })
    }
  }

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="container-fluid" style={{ height: "calc(100vh - 380px)", overflow: "hidden auto" }}>
          <div className="row">
            <div className="col-12 pb-3">
              {templateVersion === 2 && (
                <div className="mb-2">
                  <div className={styles.TaskListContainer}>
                    <FormSection
                      component={SwmsInfoSection}
                      name="info_section"
                      loading={loading}
                    />
                  </div>
                </div>
              )}
              {templateVersion !== 2 && (
                <div className="mb-2">
                  <div className={styles.TaskListContainer}>
                    <FormSection
                      component={JobSwmsDetailsSection}
                      name="details_section"
                      loading={loading}
                      swmsVersion={swms_revision}
                      swmsNumber={swms_number}
                      clientDetails={swms_data && swms_data.client_details ? swms_data.client_details : {}}
                      siteDetails={swms_data && swms_data.site_details ? swms_data.site_details : {}}
                    />
                  </div>
                </div>
              )}
              <Collapse
                accordion
                bordered={false}
                expandIconPosition="right"
                style={{ marginTop: "10px" }}
                className="custom-section-v2-collapse custom-job-swms-collapse"
                expandIcon={({ isActive }) => (
                  <Icon type="caret-right" rotate={isActive ? 90 : 0} style={{ color: "#2f1f41" }} />)
                }>
                {templateVersion === 2 && (
                  <Panel
                    key={0}
                    className="custom-job-swms-collapse-panel"
                    style={{ border: '0px !important' }}
                    header={
                      <div className={`${styles.BackgroundSectionHeading} custom-section-v2-panel-heading`} style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                        <div>Our Company</div>
                        <div style={{ textTransform: "capitalize", fontWeight: "600", fontSize: "11px", color: "#6b7280" }}>
                          <Field name="company_details.company_name" prefix=" - " component={DisplayFieldValue} />
                          <Field name="company_details.company_abn" prefix=" · ABN " component={DisplayFieldValue} />
                        </div>
                      </div>
                    }>
                    <FormSection
                      component={OurCompanySection}
                      name="company_details"
                      loading={loading}
                    />
                  </Panel>
                )}
                {templateVersion === 2 && (
                  <Panel
                    key={15}
                    className="custom-job-swms-collapse-panel"
                    style={{ border: '0px !important' }}
                    header={
                      <div className={`${styles.BackgroundSectionHeading} custom-section-v2-panel-heading`} style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                        <div>Client / Principal Contractor</div>
                        <div style={{ textTransform: "capitalize", fontWeight: "600", fontSize: "11px", color: "#6b7280" }}>
                          <Field name="client_details.client_name" prefix=" - " component={DisplayFieldValue} />
                          <Field name="client_details.client_contact_person_name" prefix=" · " component={DisplayFieldValue} />
                        </div>
                      </div>
                    }>
                    <FormSection
                      component={ClientContractorSection}
                      name="client_details"
                      loading={loading}
                    />
                  </Panel>
                )}

                <Panel
                  key={1}
                  className="custom-job-swms-collapse-panel"
                  style={{ border: '0px !important' }}
                  header={
                    <div className={`${styles.BackgroundSectionHeading} custom-section-v2-panel-heading`}>SWMS Revisions &amp; Approvals
                      <div onClick={e => { e.preventDefault(); e.stopPropagation(); }} className="float-right position-relative" style={{ right: "30px" }}>
                        <Field name="swms_review_section.toggle" size="small" className="cs-switch-v3" component={CustomSwitch} disabled={loading} />
                      </div>
                    </div>
                  }>
                  <FormSection
                    component={ReviewsSection}
                    revisionsData={swms_data && swms_data.swms_revisions_and_approvals && swms_data.swms_revisions_and_approvals.revision_and_approval_items ? swms_data.swms_revisions_and_approvals.revision_and_approval_items : []}
                    name="swms_review_section"
                    loading={loading}
                  />
                </Panel>
                {templateVersion !== 2 && (
                  <Panel
                    key={2}
                    className="custom-job-swms-collapse-panel"
                    style={{ border: '0px !important' }}
                    header={
                      <div className={`${styles.BackgroundSectionHeading} custom-section-v2-panel-heading`}>Task Details</div>
                    }>
                    <FormSection
                      component={TaskDetailsSection}
                      taskDetails={swms_data && swms_data.task_details ? swms_data.task_details : {}}
                      name="task_details_section"
                      loading={loading} />
                  </Panel>
                )}
                <Panel
                  key={3}
                  className="custom-job-swms-collapse-panel"
                  style={{ border: '0px !important' }}
                  header={
                    <div className={`${styles.BackgroundSectionHeading} custom-section-v2-panel-heading`}>High Risk Activity</div>
                  }>
                  <FormSection component={HighRisksSection} highRiskData={highRiskData} name="high_risk_section" loading={loading} />
                </Panel>
                <Panel
                  key={4}
                  className="custom-job-swms-collapse-panel"
                  style={{ border: '0px !important' }}
                  header={
                    <div className={`${styles.BackgroundSectionHeading} custom-section-v2-panel-heading`}>Permit Required
                      <div onClick={e => { e.preventDefault(); e.stopPropagation(); }} className="float-right position-relative" style={{ right: "30px" }}>
                        <Field name="permits_section.toggle" size="small" className="cs-switch-v3" component={CustomSwitch} disabled={loading} />
                      </div>
                    </div>
                  }>
                  <FormSection component={PermitsSection} name="permits_section" loading={loading} />

                </Panel>
                <Panel
                  key={5}
                  className="custom-job-swms-collapse-panel"
                  style={{ border: '0px !important' }}
                  header={
                    <div className={`${styles.BackgroundSectionHeading} custom-section-v2-panel-heading`}>Plant Equipment
                      <div onClick={e => { e.preventDefault(); e.stopPropagation(); }} className="float-right position-relative" style={{ right: "30px" }}>
                        <Field name="plant_equipment_section.toggle" size="small" className="cs-switch-v3" component={CustomSwitch} disabled={loading} />
                      </div>
                    </div>
                  }>
                  <FormSection component={PlantEquipmentSection} name="plant_equipment_section" change={change} loading={loading} />
                </Panel>
                <Panel
                  key={6}
                  className="custom-job-swms-collapse-panel"
                  style={{ border: '0px !important' }}
                  header={
                    <div className={`${styles.BackgroundSectionHeading} custom-section-v2-panel-heading`}>Materials Required
                      <div onClick={e => { e.preventDefault(); e.stopPropagation(); }} className="float-right position-relative" style={{ right: "30px" }}>
                        <Field name="materials_section.toggle" size="small" className="cs-switch-v3" component={CustomSwitch} disabled={loading} />
                      </div>
                    </div>
                  }>
                  <FormSection component={MaterialsSection} name="materials_section" change={change} loading={loading} />
                </Panel>
                <Panel
                  key={19}
                  className="custom-job-swms-collapse-panel"
                  style={{ border: '0px !important' }}
                  header={
                    <div className={`${styles.BackgroundSectionHeading} custom-section-v2-panel-heading`}>Safety Data Sheets
                      <div onClick={e => { e.preventDefault(); e.stopPropagation(); }} className="float-right position-relative" style={{ right: "30px" }}>
                        <Field name="sds_section.toggle" size="small" className="cs-switch-v3" component={CustomSwitch} disabled={loading} />
                      </div>
                    </div>
                  }>
                  <FormSection component={SdsSection} name="sds_section" change={change} loading={loading} />
                </Panel>
                <Panel
                  key={7}
                  className="custom-job-swms-collapse-panel"
                  style={{ border: '0px !important' }}
                  header={
                    <div className={`${styles.BackgroundSectionHeading} custom-section-v2-panel-heading`}>Tools
                      <div onClick={e => { e.preventDefault(); e.stopPropagation(); }} className="float-right position-relative" style={{ right: "30px" }}>
                        <Field name="tools_section.toggle" size="small" className="cs-switch-v3" component={CustomSwitch} disabled={loading} />
                      </div>
                    </div>
                  }>
                  <FormSection component={ToolsSection} name="tools_section" change={change} loading={loading} />
                </Panel>
                <Panel
                  key={8}
                  className="custom-job-swms-collapse-panel"
                  style={{ border: '0px !important' }}
                  header={
                    <div className={`${styles.BackgroundSectionHeading} custom-section-v2-panel-heading`}>PPE Requirements
                      <div onClick={e => { e.preventDefault(); e.stopPropagation(); }} className="float-right position-relative" style={{ right: "30px" }}>
                        <Field name="ppe_section.toggle" size="small" className="cs-switch-v3" component={CustomSwitch} disabled={loading} />
                      </div>
                    </div>
                  }>
                  <FormSection component={PPESection} name="ppe_section" change={change} loading={loading} />
                </Panel>
                <Panel
                  key={9}
                  className="custom-job-swms-collapse-panel"
                  style={{ border: '0px !important' }}
                  header={
                    <div className={`${styles.BackgroundSectionHeading} custom-section-v2-panel-heading`}>Training, Licenses & Competencies
                      <div onClick={e => { e.preventDefault(); e.stopPropagation(); }} className="float-right position-relative" style={{ right: "30px" }}>
                        <Field name="tlc_section.toggle" size="small" className="cs-switch-v3" component={CustomSwitch} disabled={loading} />
                      </div>
                    </div>
                  }>
                  <FormSection component={TrainingLicensesCompetenciesSection} name="tlc_section" change={change} loading={loading} />
                </Panel>
                <Panel
                  key={10}
                  className="custom-job-swms-collapse-panel"
                  style={{ border: '0px !important' }}
                  header={
                    <div className={`${styles.BackgroundSectionHeading} custom-section-v2-panel-heading`}>Legislation / Regulations / Standards & COP
                      <div onClick={e => { e.preventDefault(); e.stopPropagation(); }} className="float-right position-relative" style={{ right: "30px" }}>
                        <Field name="lsc_section.toggle" size="small" className="cs-switch-v3" component={CustomSwitch} disabled={loading} />
                      </div>
                    </div>
                  }>
                  <FormSection component={LegislationStandardCOPSection} name="lsc_section" change={change} loading={loading} />
                </Panel>
                <Panel
                  key={11}
                  className="custom-job-swms-collapse-panel"
                  style={{ border: '0px !important' }}
                  header={
                    <div className={`${styles.BackgroundSectionHeading} custom-section-v2-panel-heading`}>Risk Assessment Matrix
                      <div onClick={e => { e.preventDefault(); e.stopPropagation(); }} className="float-right position-relative" style={{ right: "30px" }}>
                        <Field name="risk_matrix_section.toggle" size="small" className="cs-switch-v3" component={CustomSwitch} disabled={loading} />
                      </div>
                    </div>
                  }>
                  <div className="container-fluid py-2">
                    <FormSection likelihoods={likelihoods} risks={risks} consequences={consequences} component={RiskMatrixSection} name="risk_matrix_section" />
                  </div>
                </Panel>
                <Panel
                  key={12}
                  className="custom-job-swms-collapse-panel"
                  style={{ border: '0px !important' }}
                  header={
                    <div className={`${styles.BackgroundSectionHeading} custom-section-v2-panel-heading`}>Job Safety Analysis (JSA) and Safe Work Method Statement SWMS</div>
                  }>
                  {templateVersion === 2 ? (
                    <FormSection component={JSASection2} likelihoods={likelihoods} consequences={consequences} name="jsa_section_2" change={change} loading={loading} />
                  ) : (
                    <FormSection component={JSASection} name="jsa_section" change={change} loading={loading} />
                  )}
                </Panel>
                <Panel
                  key={13}
                  className="custom-job-swms-collapse-panel"
                  style={{ border: '0px !important' }}
                  header={
                    <div className={`${styles.BackgroundSectionHeading} custom-section-v2-panel-heading`}>Key Contacts
                      <div onClick={e => { e.preventDefault(); e.stopPropagation(); }} className="float-right position-relative" style={{ right: "30px" }}>
                        <Field name="key_contacts_section.toggle" size="small" className="cs-switch-v3" component={CustomSwitch} disabled={loading} />
                      </div>
                    </div>
                  }>
                  <FormSection component={KeyContactsSection} name="key_contacts_section" loading={loading} />
                </Panel>
                <Panel
                  key={14}
                  className="custom-job-swms-collapse-panel"
                  style={{ border: '0px !important' }}
                  header={
                    <div className={`${styles.BackgroundSectionHeading} custom-section-v2-panel-heading`}>SWMS Consultation & Communication
                      <div onClick={e => { e.preventDefault(); e.stopPropagation(); }} className="float-right position-relative" style={{ right: "30px" }}>
                        <Field name="swms_consultation_section.toggle" size="small" className="cs-switch-v3" component={CustomSwitch} disabled={loading} />
                      </div>
                    </div>
                  }>
                  <FormSection component={SwmsConsultationsSection} name="swms_consultation_section" change={change} loading={loading} />
                </Panel>
                {templateVersion === 2 && (
                  <Panel
                    key={16}
                    className="custom-job-swms-collapse-panel"
                    style={{ border: '0px !important' }}
                    header={
                      <div className={`${styles.BackgroundSectionHeading} custom-section-v2-panel-heading`}>Authorisation Details
                        <div onClick={e => { e.preventDefault(); e.stopPropagation(); }} className="float-right position-relative" style={{ right: "30px" }}>
                          <Field name="authorisation_details_section.toggle" size="small" className="cs-switch-v3" component={CustomSwitch} disabled={loading} />
                        </div>
                      </div>
                    }>
                    <AuthorisationDetailsSection
                      approvers={swms_data && swms_data.authorisation_details && swms_data.authorisation_details.approvers ? swms_data.authorisation_details.approvers : DUMMY_APPROVERS}
                      loading={loading}
                      change={change}
                    />
                  </Panel>
                )}
                {templateVersion === 2 && (
                  <Panel
                    key={17}
                    className="custom-job-swms-collapse-panel"
                    style={{ border: '0px !important' }}
                    header={
                      <div className={`${styles.BackgroundSectionHeading} custom-section-v2-panel-heading`}>Version &amp; Approval History</div>
                    }>
                    <VersionHistorySection
                      versions={swms_data && swms_data.version_history ? swms_data.version_history : DUMMY_VERSION_HISTORY}
                      loading={loading}
                    />
                  </Panel>
                )}
              </Collapse>
            </div>
          </div>
          <div className="row">
            <div className="col-12 d-flex align-items-center justify-content-end" style={{ gap: "10px" }}>
              {loading ? (
                <CircularProgress size={20} />) : ""}
              <button className={styles.OutlinedButton} type="button" onClick={() => onClose()}>Cancel</button>
              <button disabled={loading} className={styles.PrimaryButton} type="submit">Save SWMS</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}

export default reduxForm({
  form: "job_swms_form",
  enableReinitialize: true,
  destroyOnUnmount: true
})(JobSwmsForm)